import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ZapIcon, TargetIcon, RefreshCwIcon, ShieldIcon, ClockIcon } from 'lucide-react';
const features = [{
  icon: ZapIcon,
  name: 'INTENSITY',
  desc: 'CoolTone induces muscle contractions at a much higher rate and intensity than what can be achieved through regular exercise. During a CoolTone session, your muscles contract over 25,000 times, which is significantly more than what most people can achieve with a single workout.'
}, {
  icon: TargetIcon,
  name: 'TARGETED STIMULATION',
  desc: 'CoolTone targets specific muscle groups with precision, ensuring that all areas are effectively stimulated. This targeted approach can lead to more balanced and comprehensive muscle development compared to traditional exercises, which may not isolate specific muscle groups as effectively.'
}, {
  icon: RefreshCwIcon,
  name: 'CONSISTENCY',
  desc: 'CoolTone provides consistent and controlled muscle contractions throughout the entire treatment session, whereas it can be challenging to maintain consistent intensity and form during a typical workout. This consistency ensures that each muscle fiber is adequately stimulated for optimal results.'
}, {
  icon: ShieldIcon,
  name: 'NO MICROSCOPIC TEARING',
  desc: 'During regular exercise, muscle fibers are subjected to repetitive tension and stress, leading to microscopic damage or tearing of muscle fibers. This damage prompts the body to initiate a repair process and muscles grow stronger to withstand future stress (hypertrophy). CoolTone mimics this effect, ultimately leading to improved muscle tone and definition.'
}, {
  icon: ClockIcon,
  name: 'EFFICIENCY',
  desc: 'CoolTone sessions are relatively short, typically lasting about 20 to 30 minutes, yet they deliver a high volume of muscle contractions. This efficiency allows you to achieve significant muscle activation in a shorter amount of time compared to traditional workouts, making CoolTone a convenient option for individuals with busy schedules.'
}];
export function CTVsExercise() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-802">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-803">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-804">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-805">
            MUSCLE TONING VS. TRADITIONAL EXERCISE
          </h2>

          <p className="font-serif italic text-[#B0B0B0] text-[17px] leading-[1.7] max-w-[700px] mb-6" data-id="element-806">
            CoolTone is unique because it provides consistent and controlled
            muscle contractions throughout the entire treatment session. Here
            are a few of the differences:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-807"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-808">
          {features.map((feature, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-809">
              <div className="bg-[#111111] p-8 text-center h-full group hover:shadow-[0_0_20px_rgba(255,20,147,0.1)] transition-shadow duration-300" data-id="element-810">
                <feature.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-811" />
                <h3 className="text-white font-bold text-lg uppercase font-[Poppins,_sans-serif] mb-3 tracking-wide" data-id="element-812">
                  {feature.name}
                </h3>
                <p className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-813">
                  {feature.desc}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}